export enum SURVEY_QUERY_PARAMS {
  MODE = "mode",
}

export enum SURVEY_MODE {
  FAST_FORWARD = "fast-forward",
}
